/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 07.09.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import ShowcaseSearch from '../containers/ShowcaseSearch';

import {GetPackages} from '../actions/collection/actions-collection';

class ShowcaseSearchRoute extends Component {

  componentWillMount() {
    this.props.GetPackages();
  }

  render() {

    return (
      <ShowcaseSearch searchTerm={_get(this.props, 'params.searchTerm', '')} />
    );
  }
}

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(() => ({}), mapDispatchToProps)(ShowcaseSearchRoute);



// WEBPACK FOOTER //
// ./src/routes/search-route.js